let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("868fr")).then(() => parcelRequire('3rHYj'));